import type { Bounds } from 'components/search-es/types';

// Default Toronto boundary when boundary does not exist
export const TORONTO_MAP_BOUNDARY = '{"type":"Polygon","coordinates":[[[-79.44721399360348,43.638787481133214],[-79.44721399360348,43.66766451886679],[-79.31915460639645,43.66766451886679],[-79.31915460639645,43.638787481133214],[-79.44721399360348,43.638787481133214]]]}';

/**
 * Default half-width (in degrees) for {@link boundaryAroundPoint}. 0.1 degrees of latitude is
 * approximately 11km everywhere; 0.1 degrees of longitude is ~8km at 43 degrees North (Toronto),
 * shrinking further at higher latitudes. That is roughly the radius of a mid-size urban area and
 * matches the zoom-12/13 levels that {@link generateUrlsFromLastSearch} uses for cities and
 * neighbourhoods, so the homepage "near me" teaser shows listings at a comparable scale.
 */
export const DEFAULT_FALLBACK_BOUNDARY_DELTA_DEGREES = 0.1;


export const getNSEWWithBoundaryString = (boundary: string) => {
  const boundaryObj = JSON.parse(boundary);
  const flatCoordinates = boundaryObj.coordinates.flat();
  const north = Math.max(...flatCoordinates.map((coord: any) => coord[1]));
  const south = Math.min(...flatCoordinates.map((coord: any) => coord[1]));
  const east = Math.max(...flatCoordinates.map((coord: any) => coord[0]));
  const west = Math.min(...flatCoordinates.map((coord: any) => coord[0]));
  return { north, south, east, west };
};

export const areValidBoundaryCoordinates = (boundaryString: string): boolean => {
  if (!boundaryString) return false;
  const { north, south, east, west } = getNSEWWithBoundaryString(boundaryString);
  return north !== 0 && south !== 0 && east !== 0 && west !== 0;  
};

/**
 * Builds an axis-aligned NSEW bounding box centred on the given coordinates. Intended as a
 * "good enough" proxy for "near me" when we don't have an address hierarchy to search against
 * (e.g. Cloudflare geolocates a user to a neighbourhood that isn't in Go-Search's registry).
 */
export const boundaryAroundPoint = (
  latitude: number,
  longitude: number,
  deltaDegrees: number = DEFAULT_FALLBACK_BOUNDARY_DELTA_DEGREES
): Bounds => ({
  north: latitude + deltaDegrees,
  south: latitude - deltaDegrees,
  east: longitude + deltaDegrees,
  west: longitude - deltaDegrees,
});
